import { Flag } from '../../shared/models/flag.model';
import { VesselType } from '../../shared/models/vesselType.model';
import { ClassificationSociety } from '../../shared/models/classificationSociety.model';
import { Attachment } from '../../shared/models/attachment.model';
import { NearestLocation, Authority } from '../../../../app/shared/models/enums.model';

export class FloatingCranesRequestDTO
{

    Id:string;
    RequestorId:string;
    ServiceId:number;
    VesselType:VesselType;
    VesselTypeId:number;
    NearestLocation :NearestLocation;
    Description:string;
    SupportsFromCustomer:string;
    MaxOutreach:number;
    MaxOutreachUnit:number;
    TotalWeight:number;
    EstimatedHoursToDoneRequest:number;
    ExpectedRequestExecutingDate:Date;
    Attachments:Attachment[]= [];
    MobileNumber:string;
    Fax:string;




}



